/** Read deploy version from index.html — bump once, updates JS + all images. */
export function getAssetVersion() {
  return (
    document.querySelector('meta[name="asset-version"]')?.content?.trim() ||
    '1'
  );
}

export function assetUrl(path) {
  if (!path || path.startsWith('data:') || path.startsWith('blob:')) return path;
  const base = path.split('?')[0];
  const sep = path.includes('?') ? '&' : '?';
  return `${base}${sep}v=${getAssetVersion()}`;
}
